import Disclaimer from "../components/Disclaimer";
import SEO from "../components/SEO";
import Breadcrumbs from "../components/Breadcrumbs";

const steps = [
  "You select a treatment goal.",
  "You review educational Beginner, Intermediate, and Advanced pathways.",
  "You schedule a live video consultation.",
  "A licensed VidaVital provider reviews your history and safety questionnaire.",
  "The provider decides whether laboratory testing is needed.",
  "The provider independently determines whether any therapy is medically appropriate.",
  "If prescribed, the pharmacy or clinic completes fulfillment.",
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <SEO
        title="How Peptide Treatment Works — From Questionnaire to Care"
        description="Learn how VidaVital Medical guides you from an educational questionnaire to a live provider consultation. Independent clinical judgment, transparent disclosures, and no automatic prescriptions."
        path="/how-it-works"
        breadcrumbs={[{ name: "How Treatment Works", path: "/how-it-works" }]}
      />
      <section className="vv-hero">
        <div className="vv-container py-16">
          <Breadcrumbs items={[{ name: "How Treatment Works", path: "/how-it-works" }]} />
          <div className="vv-hero-eyebrow mb-2">How Treatment Works</div>
          <h1 className="font-display text-4xl md:text-5xl">From questionnaire to provider-directed care.</h1>
        </div>
      </section>
      <section className="vv-container py-14 max-w-3xl">
        <ol className="space-y-6">
          {steps.map((s, i) => (
            <li key={s.slice(0, 40)} className="flex gap-4">
              <div className="w-10 h-10 rounded-full bg-amber-50 border border-amber-200 text-[color:var(--vv-teal)] grid place-items-center font-display font-semibold">{i + 1}</div>
              <div className="pt-1.5 text-stone-700">{s}</div>
            </li>
          ))}
        </ol>
        <div className="mt-10 space-y-4">
          <Disclaimer variant="consultation" />
          <Disclaimer variant="payment" />
        </div>
      </section>
    </div>
  );
}
